import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {HttpClientModule} from '@angular/common/http';

// import { NotFoundComponent } from './not-found/not-found.component';
import {AuthGuardService} from './guards/auth/auth-guard.service';

// import { LoginComponent } from './login/login.component';
import {DashboardModule} from 'src/app/modules/dashboard/dashboard.module';

//Components
import {HomeComponent} from '../pages/home/home.component';
import {MainComponent} from '../pages/main/main.component';
import {LoginComponent} from '../pages/login/login.component';
import {RegisterComponent} from '../pages/register/register.component';
import {OpenlinkComponent} from '../pages/openLink/openlink.component';
import {NextstepsComponent} from '../pages/nextsteps/nextsteps.component';
import {ViewallComponent} from '../pages/viewall/viewall.component';
import {FaqComponent} from '../components/shared/footer/faq/faq.component';
import {UsageInstructionsComponent} from '../components/shared/footer/usage-instructions/usage-instructions.component';
import {PrivacyPolicyComponent} from '../components/shared/footer/privacy-policy/privacy-policy.component';
import {ContactComponent} from '../components/shared/footer/contact/contact.component';

const routes: Routes = [
  {
    path: ':lang',
    children: [
      {
        path: '',
        component: MainComponent,
      },
      //, canActivate: [AuthGuard] add authguard
      {
        path: 'login',
        component: LoginComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: 'signin',
        component: RegisterComponent,
        canActivate: [AuthGuardService],
      },
      {
        path: 'dashboard',
        loadChildren: '../modules/dashboard/dashboard.module#DashboardModule',
        canActivate: [AuthGuardService],
      },
      {
        path: 'viewall',
        component: ViewallComponent,
      },
      {
        path: 'open-lock/:id',
        component: OpenlinkComponent,
    //    canActivate: [AuthGuardService],
      },
      {
        path: 'login', 
        redirectTo: '', 
        pathMatch: 'full'
      },
      {
        path: '**', 
        loadChildren: '../modules/dashboard/dashboard.module#DashboardModule',
        canActivate: [AuthGuardService],
      },
    ],
  },

  {path: '', redirectTo: '/:lang', pathMatch: 'full'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes), HttpClientModule],
  exports: [RouterModule],
})
export class CoreRoutingModule {}
